import { useHeaderRootContext } from '../../../HeaderRoot/context/hooks/useHeaderRootContext.js';
import { useButtonProps } from '../useButtonProps/useButtonProps.js';
import { useRegisterSearchFieldButton } from '../useRegisterSearchFieldButton/useRegisterSearchFieldButton.js';
import { useSearchIconProps } from '../useSearchIconProps/useSearchIconProps.js';
import { useTitleContainerProps } from '../useTitleContainerProps/useTitleContainerProps.js';

/**
 * Main hook for HeaderSearchFieldButton that composes other specialized hooks
 * following the Single Responsibility Principle
 */
var useHeaderSearchFieldButton = function useHeaderSearchFieldButton(props) {
  // Register with context
  useRegisterSearchFieldButton();

  // Get context data
  var _useHeaderRootContext = useHeaderRootContext(),
    isTransparent = _useHeaderRootContext.isTransparent;

  // Create specialized props using dedicated hooks
  var buttonProps = useButtonProps(props, isTransparent);
  var searchIconProps = useSearchIconProps(props.isDisabled);
  var titleContainerProps = useTitleContainerProps();
  return {
    buttonProps: buttonProps,
    searchIconProps: searchIconProps,
    titleContainerProps: titleContainerProps
  };
};

export { useHeaderSearchFieldButton };
//# sourceMappingURL=useHeaderSearchFieldButton.js.map
